/**
 * `condition && styles` as a function call so it doesn't count as a branch
 * for ESLint's `complexity` rule.
 * @param {boolean} condition
 * @param {object} styles
 * @returns {object}
 */
export const styleCondition = (condition, styles) => (condition ? styles : {});
